import { useEffect, useState } from 'react';
import { collection, doc, onSnapshot } from '@battleops/localstore';
import { db } from './store';

// Live reads straight from the on-device store — they work with no signal and update as sync lands.

export function useLocalCollection(name) {
  const [rows, setRows] = useState([]);
  useEffect(() => onSnapshot(collection(db, name), (snap) => setRows(snap.docs.map((d) => ({ id: d.id, ...d.data() })))), [name]);
  return rows;
}

export function useLocalDoc(name, id) {
  const [row, setRow] = useState(null);
  useEffect(() => {
    if (!id) { setRow(null); return undefined; }
    return onSnapshot(doc(db, name, id), (snap) => setRow(snap.exists() ? { id: snap.id, ...snap.data() } : null));
  }, [name, id]);
  return row;
}

/** Like useLocalCollection, plus whether the first read has landed: [rows, ready]. */
export function useLocalCollectionReady(name) {
  const [state, setState] = useState({ rows: [], ready: false });
  useEffect(() => onSnapshot(collection(db, name), (snap) => setState({ rows: snap.docs.map((d) => ({ id: d.id, ...d.data() })), ready: true })), [name]);
  return [state.rows, state.ready];
}
